import { prosData, consData } from "@/mocks/homepageData";
import { useScrollReveal, getRevealClasses } from "@/hooks/useScrollReveal";

export default function ProsConsSection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal(0.1);

  return (
    <section ref={sectionRef} className={`py-20 md:py-28 bg-[#111827] ${getRevealClasses(sectionVisible, "up")}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#7C3AED]/40 mb-6">
            <i className="ri-scales-3-line text-[#7C3AED]"></i>
            <span className="text-sm text-[#F8FAFC]">Honest Assessment</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F8FAFC] mb-4">
            Pros &{" "}
            <span className="text-gradient">Cons</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            We test every broker honestly. Here is what we found about XM.
          </p>
        </div>

        {/* Split Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
          {/* Pros Card */}
          <div className="bg-[#1F2937] rounded-xl border border-[#374151] overflow-hidden">
            <div className="px-6 md:px-8 py-5 border-b border-[#374151] flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#10B981]/15 flex items-center justify-center">
                <i className="ri-thumb-up-line text-[#10B981]"></i>
              </div>
              <h3 className="text-lg font-bold text-[#10B981]">Advantages</h3>
            </div>
            <div className="p-6 md:p-8">
              <ul className="space-y-4">
                {prosData.map((pro, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#10B981]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#10B981] text-xs"></i>
                    </div>
                    <span className="text-[#F8FAFC] text-sm leading-relaxed">{pro}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Cons Card */}
          <div className="bg-[#1F2937] rounded-xl border border-[#374151] overflow-hidden">
            <div className="px-6 md:px-8 py-5 border-b border-[#374151] flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#64748B]/15 flex items-center justify-center">
                <i className="ri-thumb-down-line text-[#64748B]"></i>
              </div>
              <h3 className="text-lg font-bold text-[#64748B]">Disadvantages</h3>
            </div>
            <div className="p-6 md:p-8">
              <ul className="space-y-4">
                {consData.map((con, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#64748B]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-[#64748B] text-xs"></i>
                    </div>
                    <span className="text-[#94A3B8] text-sm leading-relaxed">{con}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}